<template>
  <v-container v-resize="getWindowWidth">
    <div
      v-if="isLoading"
      class="d-flex justify-center align-center"
      style="height: 100vh;"
    >
      <v-progress-circular
        indeterminate
        color="#2661FF"
        size="80"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <div
            class="text-h6 grey--text text--darken-3 font-weight-medium mb-2 ml-6"
            style="font-size: 20px !important;"
          >
            {{ $t("organization_billing.organization_report.title") }}
          </div>
          <v-breadcrumbs
            divider=">"
            :items="breadcrumbItems"
            class="pa-0 pl-6"
          ></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"><OrganizationStats /></v-col>
      </v-row>
      <!-- TODO: Organization chart -->
      <!-- <v-row class="mt-4">
        <v-col cols="12">
          <OrganizationCharts />
        </v-col>
      </v-row> -->
    </div>
  </v-container>
</template>

<script>
import OrganizationStats from "@/components/Organization/Reports/Index/OrganizationStats";
import OrganizationCharts from "@/components/Organization/Reports/Index/OrganizationCharts";

export default {
  name: "organizationReports",
  components: {
    OrganizationStats,
    OrganizationCharts
  },
  data() {
    return {
      isLoading: false,
      breadcrumbItems: [
        {
          text: this.$t("organization.title"),
          disabled: false
        },
        {
          text: this.$t("organization_billing.organization_report.title"),
          disabled: true,
          href: ""
        }
      ]
    };
  },
  async created() {},
  computed: {},
  methods: {
    getWindowWidth() {
      if (process.client) {
        this.width =
          window.innerWidth > 800
            ? window.innerWidth * 0.94
            : window.innerWidth;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
